var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C4.67157 1 4 1.67157 4 2.5V21.5C4 22.3284 4.67157 23 5.5 23H18.5C19.3284 23 20 22.3284 20 21.5V7L14 1H5.5Z",
    fill: "#6491CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23C4.67157 23 4 22.3284 4 21.5V21.25C4 22.0784 4.67157 22.75 5.5 22.75H18.5C19.3284 22.75 20 22.0784 20 21.25V21.5C20 22.3284 19.3284 23 18.5 23H5.5Z",
    fill: "#417EE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1C4.67157 1 4 1.67157 4 2.5V2.75C4 1.92157 4.67157 1.25 5.5 1.25H14.25L14 1H5.5Z",
    fill: "#639AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 12.125V7L19.1247 6.125H14.905C14.571 6.125 14.4036 6.52893 14.6399 6.76517L19.9997 12.125Z",
    fill: "url(#paint0_linear_911_1692)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1L20 7H15.5C14.6716 7 14 6.32843 14 5.5V1Z",
    fill: "#A6C5FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.25H11.75V13.25H17.25V12.25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 14.75H11.75V15.75H17.25V14.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 17.25H17.25V18.25H11.75V17.25Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8.3125C0.75 7.86377 1.11377 7.5 1.5625 7.5H9.6875C10.1362 7.5 10.5 7.86377 10.5 8.3125V16.4375C10.5 16.8862 10.1362 17.25 9.6875 17.25H1.5625C1.11377 17.25 0.75 16.8862 0.75 16.4375V8.3125Z",
    fill: "#3770C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70919 14.9596L2.64648 9.53125H3.56848L4.23499 13.26L5.0496 9.53125H6.11971L6.901 13.3229L7.58602 9.53125H8.4895L7.40828 14.9596H6.45296L5.56429 10.9013L4.68302 14.9596H3.70919Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_1692",
    x1: 16.9997,
    y1: 12.125,
    x2: 16.9997,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E8DF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D6ACD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWordIcon);
export default __webpack_public_path__ + "static/media/fileWordIcon.a8ac70e69f6fa55fef2e8df98e90ac73.svg";
export { ForwardRef as ReactComponent };